<app-modal-box [maxWidth]="700" [allowOverflow]="true">
  <ng-container modal-header>
    <div class="ticket-modal-title">Issue Category</div>
  </ng-container>
  <div class="content">
    <div class="switch">
      @for(category of supportService.categories; track category.id ){
      <button class="button item transparent" [class.red-secondary]="selectedCategory === category.id" (click)="selectCategory(category.id)">
        {{ category.name }}
      </button>
      }
    </div>
    <div class="ticket-input-group">
      <label for="ticketTitle">Ticket Title*</label>
      <input id="ticketTitle" type="text" [(ngModel)]="title" placeholder="Enter a title" class="ticket-input" />
    </div>
    <div class="ticket-input-group">
      <label for="ticketAdditionalInfo">Additional Information</label>
      <input id="ticketAdditionalInfo" type="text" [(ngModel)]="associated" placeholder="Game ID, Trade ID, Transaction ID, etc" class="ticket-input" />
    </div>
    <div class="ticket-input-group">
      <label for="ticketTextArea">Description*</label>
      <textarea id="ticketTextArea" rows="6" [(ngModel)]="description" placeholder="Enter a description to help us understand your problem" class="ticket-input"></textarea>
    </div>
  </div>
  <button class="button red create-button" [class.disabled]="!title || !description" (click)="createTicket()">Create Ticket</button>
</app-modal-box>
